/**
 * Helper functions per UnifiedRightPanel e sotto-componenti
 */

export function getTypeLabel(type: string): string {
  switch (type) {
    case 'feature_request': return 'Feature';
    case 'bug_report': return 'Bug';
    case 'status_inquiry': return 'Info';
    case 'support_request': return 'Supporto';
    case 'task_request': return 'Task';
    case 'crm_update': return 'Scheda';
    default: return 'Richiesta';
  }
}

export function getTypeBadgeColor(type: string): string {
  switch (type) {
    case 'bug_report': return 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400';
    case 'feature_request': return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400';
    case 'support_request': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
    case 'task_request': return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400';
    case 'status_inquiry': return 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
    default: return 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
  }
}

export function getTypeIcon(type: string): string {
  switch (type) {
    case 'bug_report': return '🐛';
    case 'feature_request': return '✨';
    case 'support_request': return '🆘';
    case 'task_request': return '📋';
    case 'status_inquiry': return '❓';
    default: return '💬';
  }
}

export const getDealStatusClass = (status: string) => {
  switch (status) {
    case 'accepted': return 'text-[#0F7B6C] bg-[#DBEDDB] dark:bg-[#2B4B3F] dark:text-[#6BC9B5]';
    case 'rejected': return 'text-[#E16259] bg-[#FFE2DD] dark:bg-[#5C2B29] dark:text-[#E57B78]';
    case 'sent': return 'text-[#337EA9] bg-[#D3E5EF] dark:bg-[#294350] dark:text-[#529CCA]';
    case 'draft': return 'text-[#CB912F] bg-[#FBF3DB] dark:bg-[#59563B] dark:text-[#FFDC49]';
    default: return 'text-[#787774] bg-[#F1F1F0] dark:bg-gray-700 dark:text-gray-400';
  }
};

export const getDealStatusLabel = (status: string) => {
  switch (status) {
    case 'draft': return 'Bozza';
    case 'sent': return 'Inviata';
    case 'accepted': return 'Accettata';
    case 'rejected': return 'Rifiutata';
    default: return status;
  }
};

export const getProjectStatusClass = (status: string) => {
  switch (status) {
    case 'active': case 'in_progress': return 'text-[#337EA9] bg-[#D3E5EF] dark:bg-[#294350] dark:text-[#529CCA]';
    case 'completed': return 'text-[#0F7B6C] bg-[#DBEDDB] dark:bg-[#2B4B3F] dark:text-[#6BC9B5]';
    case 'on_hold': case 'paused': return 'text-[#CB912F] bg-[#FBF3DB] dark:bg-[#59563B] dark:text-[#FFDC49]';
    case 'cancelled': return 'text-[#E16259] bg-[#FFE2DD] dark:bg-[#5C2B29] dark:text-[#E57B78]';
    default: return 'text-[#787774] bg-[#F1F1F0] dark:bg-gray-700 dark:text-gray-400';
  }
};

export const getProjectStatusLabel = (status: string) => {
  switch (status) {
    case 'active': case 'in_progress': return 'Attivo';
    case 'completed': return 'Completato';
    case 'on_hold': case 'paused': return 'In pausa';
    case 'cancelled': return 'Annullato';
    case 'planning': return 'Pianificazione';
    default: return status;
  }
};

export const formatShortDate = (d: string) =>
  new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: 'short' });

// Routing: request_type → CRM section
export const PROJECT_TYPES = new Set(['task_request', 'feature_request', 'bug_report']);
export const ACTIVITY_TYPES = new Set(['support_request', 'status_inquiry']);
